// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"sessionsInfoTable_tableHeader__3vpb5","tr":"sessionsInfoTable_tr__1w_kT"};